let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("beQsL")).then(() => parcelRequire('3C0kZ'));